export interface AclRole {
  id?: number;
  environmentId?: number;
  name?: string;
  description?: string;
  state?: string;
  reference?: string;
  allPermissions?: number;
  role?: string;
  level?: string;
  permissions?: any;
  access?: string;
  protected?: boolean;
  aclPermissions?: any;
}
